<template lang="html">
  <div
    ref="top"
    class="widgets-phd-test copytext-article"
  >
    <div v-if="isFirstStep">
      <p>Wir werden Ihnen gleich 20 Aussagen präsentieren und Sie befragen, inwiefern die jeweiligen Aussagen auf Sie zutreffen. Um ein aussagekräftiges Ergebnis gewährleisten zu können, ist es wichtig, dass Sie alle Fragen so ehrlich wie möglich beantworten. Bei diesem Quiz geht es nicht darum sich gut zu verkaufen, sondern realistische Einschätzungen abzugeben. Nur so kann das Ergebnis sinnvoll interpretiert werden.*</p>
      <p><strong>Viel Spaß beim Bearbeiten des Promotions-Tests!</strong></p>
      <p class="widgets-phd-test__footnote">
        * Die für das Test-Ergebnis relevanten Antworten und das Test-Ergebnis selbst werden nicht mit den Nutzerprofilen verknüpft. Somit werden auch keine personenbezogenen Daten erhoben oder gespeichert.
      </p>
    </div>
    <div v-else-if="step < 5">
      <p
        v-for="(question) in questions"
        :key="question.id"
        class="widgets-phd-test__question"
      >
        <span class="widgets-phd-test__question-text">{{ question.id }} - {{ question.text }}</span>
        <span
          v-for="(answer, val) in answers"
          :key="val"
          class="widgets-phd-test__answer"
        >
          <input
            :id="`phd-${question.id}-${val}`"
            v-model="model[question.id]"
            type="radio"
            :value="val"
            class="custom-input custom-input--radio custom-input--medium-above"
          >
          <label
            :for="`phd-${question.id}-${val}`"
            class="widgets-phd-test__answer-text"
          >{{ answer }}</label>
        </span>
      </p>
    </div>
    <div v-else-if="step == 5">
      <p>Vielen Dank für Ihre Teilnahme an unserem Promotions-Test.</p>
      <p><strong>Sie haben {{ score }} von 109 maximal möglichen Punkten erreicht.</strong></p>
      <p>Bitte lesen Sie die folgenden Erklärungen aufmerksam durch, um Ihr Ergebnis sinnvoll einordnen und interpretieren zu können. Lesen Sie dazu möglichst die Information zu allen Kategorien sowie die allgemeinen Informationen zum Test.</p>
      <p>Allgemeine Anmerkungen: Wie bereits eingangs erwähnt sollte Ihr Ergebnis natürlich nicht als einziges Kriterium für eine Entscheidung über eine Promotion herangezogen werden. Der Test kann Ihnen dabei helfen, wichtige Eigenschaften und Voraussetzungen zu identifizieren und Ihnen einen Eindruck vermitteln, inwiefern Sie diesen entsprechen. Denken Sie bitte auch noch einmal darüber nach, ob Sie die Fragen wirklich ehrlich und realistisch beantwortet haben. Waren Sie vielleicht zu vorsichtig oder zu großzügig in Ihren Antworten? Nur bei realistischen Einschätzungen kann Ihr Ergebnis sinnvoll interpretiert werden.</p>
      <div
        v-for="result in results"
        :key="result.title"
      >
        <hr>
        <template v-if="result.predicate(score)">
          <h5><strong>{{ result.title }}</strong></h5>
          <p><strong>{{ result.text }}</strong></p>
        </template>
        <template v-else>
          <h5>{{ result.title }}</h5>
          <p>{{ result.text }}</p>
        </template>
      </div>
    </div>
    <div v-else-if="step == 6">
      <p>Die nachfolgenden Hinweise sollen Ihnen Anhaltspunkte liefern, welche Eignungen und Fähigkeiten in besonderem Maße für die verschiedenen Promotionsarten von Relevanz sind.</p>
      <p>Bitte beachten Sie jedoch, dass die Unterschiede zwischen einzelnen Programmen innerhalb einer Promotionsart immer noch beträchtlich sein können. So sind beispielsweise universitätsinterne Promotionen in einem Drittmittelprojekt häufig stärker vorstrukturiert, als Promotionen auf regulären Landesstellen. Informieren Sie sich vorab gut über die spezifischen Anforderungen, wie Sie durch Promotionsordnung definiert werden, und klären Sie Details mit Ihrem zukünftigen Betreuer ab.</p>
      <p>Eine der wichtigsten Fähigkeiten für die klassische, universitätsinterne Promotion ist die <strong>Selbstständigkeit</strong> im Umgang mit nur wenig vordefinierten Rahmenbedingungen und Strukturen. Sie haben hier {{ (6 + (model['14'] - model['6'])) / 2 }} von 5 möglichen Punkten erzielt.</p>
      <p>Dadurch, dass Sie in der universitätsinternen Promotion stärker auf sich allein gestellt sind und weniger Anleitung durch äußere Strukturen erhalten, ist <strong>Prokrastinationsverhalten</strong> (d.h. aufschieben von unliebsamen Aufgaben) besonders hinderlich. In Ihrer Fähigkeit Prokrastination zu vermeiden erreichen Sie {{ model['10'] }} von 5 möglichen Punkten.</p>
      <p>Darüber hinaus gilt bei der klassischen Promotion, dass viele Aufgaben und Arbeitsschritte nur sehr ungenau über längere Zeiträume festgelegt, und damit wenig planbar sind. In Bezug auf Ihre persönliche <strong>Toleranz gegenüber dieser schlechten Planbarkeit</strong> haben Sie {{ 6 - model['5'] }} von 5 möglichen Punkten erzielt.</p>
      <p>Strukturierte Promotionsprogramme zeichnen sich in ihrem Arbeitsalltag dadurch aus, dass viele häufig wechselnde Tätigkeiten zu erledigen sind und wenige Tage exakt identisch ablaufen. In Ihrer <strong>Flexibilität</strong> sich diesen ständig <strong>wechselnden Aufgabenstellungen</strong> erfolgreich zu stellen erreichen Sie {{ model['15'] }} von 5 möglichen Punkten.</p>
    </div>

    <div class="flex-container align-justify widgets-phd-test__actions">
      <button
        v-if="!isFirstStep"
        ref="prevStep"
        :href="`#step_${step - 1}`"
        :disabled="isPrevDisabled"
        class="button button--tertiary widgets-phd-test__button"
        @click="prevStep"
      >
        Zurück
      </button>
      <button
        v-if="!isLastStep"
        ref="nextStep"
        :href="`#step_${step + 1}`"
        :disabled="isNextDisabled"
        class="button button--secondary widgets-phd-test__button"
        @click="nextStep"
      >
        {{ nextText }}
      </button>
      <a
        v-if="isLastStep"
        :href="'client.phd_test.guide_link' | t"
        :data-ac-click="guideLinkTracking"
        class="button button--secondary widgets-phd-test__button"
      >Zum Ratgeber Promotion</a>
    </div>
  </div>
</template>

<script>
import jump from 'jump.js-cancelable'

import questions from './questions'
import answers from './answers'
import results from './results'

const QUESTIONS_PER_STEP = 5
const QUESTION_STEPS = Math.ceil(questions.length / QUESTIONS_PER_STEP)
const TOTAL_STEPS = QUESTION_STEPS + 3
const MAGIC_SCORE_OFFSET = 32.5

const nextTexts = [
  { predicate: step => step === 0, text: 'Test starten' },
  { predicate: step => step === QUESTION_STEPS, text: 'Zur Auswertung' },
  { predicate: step => step === QUESTION_STEPS + 1, text: 'Weiter: Art der Promotion' },
  { predicate: step => true, text: 'Weiter' }
]

export default {
  data: () => ({
    step: 0,
    answers,
    model: {},
    guideLinkTracking: JSON.stringify({ 9: 'visit_guide' })
  }),
  computed: {
    isFirstStep () {
      return this.step === 0
    },
    isLastStep () {
      return this.step === TOTAL_STEPS - 1
    },
    isNextDisabled () {
      const currentStepQuestionIds = this.questions.map(q => q.id)
      const answeredQuestions = Object.keys(this.model)
      return !currentStepQuestionIds.every(id => answeredQuestions.includes(id))
    },
    isPrevDisabled () {
      return this.step === 0
    },
    isQuestionStep () {
      return this.step < 1 || this.step > QUESTION_STEPS + 1
    },
    nextText () {
      return nextTexts.find(item => item.predicate(this.step)).text
    },
    questionSteps () {
      return Math.ceil(questions.length / QUESTIONS_PER_STEP)
    },
    questions () {
      if (this.isQuestionStep) {
        return []
      } else {
        const offset = QUESTIONS_PER_STEP * (this.step - 1)
        return questions.slice(offset, offset + QUESTIONS_PER_STEP)
      }
    },
    results () {
      return [...results].sort((resultA, resultB) => (resultA.predicate(this.score) && -1) || 1)
    },
    score () {
      if (Object.keys(this.model).length === questions.length) {
        return Math.ceil(questions.reduce((acc, q) => acc + q.weight * this.model[q.id], MAGIC_SCORE_OFFSET))
      } else {
        return 0
      }
    }
  },
  methods: {
    focusTop () {
      jump.jump(this.$refs.top, {
        offset: -24,
        duration: distance => Math.max(Math.abs(distance), 300)
      })
    },
    nextStep () {
      this.step++
      EventBus.trigger('tracking:manualEventTrack', { action_type: 'step_next', $elem: $(this.$refs.nextStep) })
      this.$nextTick(() => {
        this.focusTop()
      })
    },
    prevStep () {
      this.step--
      EventBus.trigger('tracking:manualEventTrack', { action_type: 'step_prev', $elem: $(this.$refs.prevStep) })
      this.$nextTick(() => {
        this.focusTop()
      })
    }
  }
}
</script>
